import angular from 'angular';
angular.module('cxRegistrations').directive('editableResourceTypeahead', [
  'editableDirectiveFactory',
  '$timeout',
  function(editableDirectiveFactory, $timeout) {
    var dir = editableDirectiveFactory({
      directiveName: 'editableResourceTypeahead',
      inputTpl: '<cx-resource-typeahead ng-change="submitOnChange()"></cx-resource-typeahead>',
      render: function() {
        this.parent.render.call(this);
      },
      autosubmit: function() {
        var self = this;
        self.scope.submitOnChange = function() {
          $timeout(function() {
            self.scope.$form.$submit();
          }, 100);
        };
        self.editorEl.on('keyup', function(e) {
          if (!self.single) {
            return;
          }
          switch (e.keyCode) {
            // hide on `escape` press
            case 27:
              self.scope.$apply(function() {
                self.scope.$form.$cancel();
              });
              break;
          }
        });
      },
    });
    return dir;
  },
]);
